
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chatgpt-ui-alternative",
      function () {
        return require("private-next-pages/chatgpt-ui-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chatgpt-ui-alternative"])
      });
    }
  